var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBookmarkRemove = function SvgBookmarkRemove(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    viewBox: "0 0 19 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M12.503 6.093a.76.76 0 0 1-.557-.225.76.76 0 0 1-.225-.556q0-.333.225-.557a.76.76 0 0 1 .557-.225h3.125q.332 0 .557.225.225.224.225.557a.76.76 0 0 1-.225.556.76.76 0 0 1-.557.225zm-3.126 8.596-3.282 1.406q-.78.333-1.485-.127-.702-.459-.703-1.299V4.53q0-.645.46-1.104.458-.459 1.103-.459h3.907q.332 0 .557.225.225.224.224.557a.76.76 0 0 1-.224.556.76.76 0 0 1-.557.225H5.47v10.12l3.907-1.68 3.907 1.68V10q0-.332.225-.557a.76.76 0 0 1 .556-.224q.333 0 .557.224.225.225.225.557v4.669q0 .84-.703 1.3-.704.458-1.485.126zm0-10.159H5.47h4.688z"
  })));
};
export default SvgBookmarkRemove;